<section class="relative flex flex-col items-center w-full">
  <div class="relative flex flex-col w-full max-w-5xl gap-6 px-2">
    <div>
      <h1 class="font-display text-2xl md:text-3xl font-bold text-gray-900">Portail client</h1>
      <p class="text-gray-500 mt-1">Suivez les échanges de documents et les demandes client.</p>
    </div>

    <div class="grid grid-cols-2 lg:grid-cols-3 gap-4">
      <article class="rounded-xl border border-gray-200 bg-white p-4">
        <p class="text-xs text-gray-500">Invitations / clients</p>
        <p class="text-2xl font-bold text-gray-900">{{ entries().length }}</p>
      </article>
      <article class="rounded-xl border border-gray-200 bg-white p-4">
        <p class="text-xs text-gray-500">Documents à traiter</p>
        <p class="text-2xl font-bold text-gray-900">{{ totalItems() }}</p>
      </article>
      <article class="rounded-xl border border-gray-200 bg-white p-4">
        <p class="text-xs text-gray-500">Clients actifs</p>
        <p class="text-2xl font-bold text-gray-900">{{ pendingCount() }}</p>
      </article>
    </div>

    @if (pendingCount() > 0) {
      <div class="rounded-2xl bg-amber-50 border border-amber-200 p-4">
        <h3 class="text-sm font-semibold text-amber-800 mb-1">
          {{ pendingCount() }} client(s) avec des documents à consulter
        </h3>
        <p class="text-xs text-amber-700">Validez, rejetez ou complétez les demandes depuis le détail client.</p>
      </div>
    }

    <article class="rounded-xl border border-gray-200 bg-white overflow-hidden">
      @if (loading()) {
        <p class="p-5 text-sm text-gray-500">Chargement...</p>
      } @else if (!entries().length) {
        <p class="p-5 text-sm text-gray-500">Aucun client a afficher.</p>
      } @else {
        <div class="divide-y divide-gray-100">
          @for (entry of entries(); track entry.company.siret) {
            <div>
              <button type="button" class="w-full p-4 flex items-center justify-between hover:bg-gray-50 text-left cursor-pointer" (click)="toggleClient(entry.company.siret)">
                <div>
                  <h2 class="font-semibold text-gray-900">{{ entry.company.nomEntreprise }}</h2>
                  <p class="text-xs text-gray-500">{{ entry.company.siretFormatte }}</p>
                </div>
                <div class="text-xs text-gray-500">{{ entry.items.length }} doc(s)</div>
              </button>

              @if (expandedClient() === entry.company.siret) {
                <div class="px-4 pb-4 bg-gray-50">
                  <div class="rounded-xl border border-gray-200 bg-white p-1 inline-flex gap-1 mb-3">
                    <button type="button" class="px-2 py-1 rounded text-xs cursor-pointer" [class.bg-secondary]="activeTab() === 'documents'" [class.text-white]="activeTab() === 'documents'" (click)="activeTab.set('documents')">
                      Documents ({{ entry.items.length }})
                    </button>
                    <button type="button" class="px-2 py-1 rounded text-xs cursor-pointer" [class.bg-secondary]="activeTab() === 'messages'" [class.text-white]="activeTab() === 'messages'" (click)="activeTab.set('messages')">
                      Messages
                    </button>
                    <button type="button" class="px-2 py-1 rounded text-xs cursor-pointer" [class.bg-secondary]="activeTab() === 'required'" [class.text-white]="activeTab() === 'required'" (click)="activeTab.set('required')">
                      Requis
                    </button>
                  </div>

                  @if (activeTab() === 'documents') {
                    @if (!entry.items.length) {
                      <p class="text-xs text-gray-500 py-2">Aucun document déposé pour le moment.</p>
                    } @else {
                      <div class="space-y-1">
                        @for (item of entry.items; track item.id) {
                          <div class="text-sm bg-white border border-gray-200 rounded-lg px-3 py-2">
                            {{ item.name }} <span class="text-xs text-gray-500">({{ item.type }})</span>
                          </div>
                        }
                      </div>
                    }
                  }

                  @if (activeTab() === 'messages') {
                    <div class="rounded-lg border border-gray-200 bg-white p-4 text-xs text-gray-500">
                      Messagerie client disponible prochainement.
                    </div>
                  }

                  @if (activeTab() === 'required') {
                    <div class="rounded-lg border border-gray-200 bg-white p-4 text-xs text-gray-500">
                      Gestion des documents requis disponible prochainement.
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
      }
    </article>
  </div>
</section>
